import Avatar from "../../Avatar";
import { userTypeConvert } from "@/utils/helper";
import Link from "next/link";
import { PAGE_URL } from "@/utils/constants";
import { motion } from "framer-motion";
import { capitalize } from "lodash";
import { CSSProperties, useState } from "react";
import ModalMutualConnection from "../../pages/connection/ModalMutualConnection";
import useOrgSettingStore from "@/store/useOrgSettingsStore";
import cx from "classnames";
interface ICardUserProfile {
  styleTier?: CSSProperties;
  mutualCount?: number;
  hideJobType?: boolean;
  hideCG?: boolean;
  item: {
    id: string;
    email: string;
    organizationGroup: string;
    firstName: string;
    lastName: string;
    avatarUrl: string;
    jobTitle: string;
    type: string;
    lookingForType: string;
    points: number;
    department: {
      id: string;
      name: string;      
    };    
  };
  variant?: "vertical" | "horizontal";
  className?: string;
  hideType?: boolean;
  isChampion?: boolean;
  disableHref?: boolean;
  hideMutual?: boolean;
  avatarSize?: "xxs" | "xs" | "sm" | "sm" | "md" | "lg" | "xl" | "2xl";
  customType?: string | any;
  squareAvatar?: boolean;
  avatarOnly?: boolean;
  hideOnlyType?: boolean;
  CGP?: string | number;
  containerClassName?: string;
  type?: "profile" | "circle" | "event";
  isOneLineName?: boolean;
  isNameCapitalized?: boolean;
  nameClassName?: string
}

export default function CardUserProfile({
  item,
  mutualCount,
  variant = "vertical",
  className,
  hideType,
  isChampion,
  disableHref,
  hideMutual,
  avatarSize,
  customType,
  squareAvatar,
  hideJobType,
  avatarOnly,  
  styleTier,
  hideOnlyType,
  hideCG,
  CGP,
  containerClassName = "",
  type = "profile",
  isOneLineName = false,
  isNameCapitalized = true,
  nameClassName
}: ICardUserProfile) {
  const [showMutualConnection, setShowMutualConnection] = useState<{
    isOpen: boolean;
    userId: any;
  }>({
    isOpen: false,
    userId: null,
  });  

  const LinkMotion = motion(Link);

  const hrefLink: Record<string, string> = {
    profile: PAGE_URL.profile,
    circle: PAGE_URL.circles,
    event: PAGE_URL.events,
  };

  const Wrapper = ({ children }: { children: any }) =>
    disableHref ? (
      <motion.div className={className}>{children}</motion.div>
    ) : (
      <LinkMotion
        href={`${hrefLink[type]}/${item?.id}`}
        whileHover={{ scale: 0.99 }}
        className={className}
      >
        {children}
      </LinkMotion>
    );

  const { pointTiers } = useOrgSettingStore();
  const typeTier = () => {
    if (pointTiers?.platinum && item?.points && item?.points >= pointTiers?.platinum) return "PLATINUM";
    if (pointTiers?.gold && item?.points && item?.points >= pointTiers?.gold) return "GOLD";
    if (pointTiers?.silver && item?.points && item?.points >= pointTiers?.silver) return "SILVER";
    if (pointTiers?.bronze != null && item?.points != null && item?.points >= pointTiers?.bronze)
      return "BRONZE";
    return "";
  };  

  return (
    <>
      {avatarOnly && (
        <Avatar
          src={item?.avatarUrl}
          alt="avatar"
          badge={hideCG ? null : CGP}
          type_tier={typeTier() as never}
          size={avatarSize || "lg"}
          isRounded={!squareAvatar}
          name={item?.firstName}
        />
      )}
      {!avatarOnly && (
        <Wrapper>
          {variant === "vertical" && (
            <div className={`flex flex-col items-center pb-4 relative pt-16 ${containerClassName}`}>
              <div>
                <Avatar
                  src={item?.avatarUrl}
                  alt="avatar"
                  badge={hideCG ? null : CGP}
                  type_tier={typeTier() as never}
                  size={avatarSize || "lg"}
                  isRounded={!squareAvatar}
                  styleTier={styleTier}
                  name={item?.firstName}
                />
              </div>
              <div className="text-center">
                {!hideJobType && <p className="text-[10px] text-[#D9D9D9]">{item?.jobTitle}</p>}
                <p className={`text-sm font-bold ${isChampion && "text-yellow"} line-clamp-2 overflow-hidden text-ellipsis`} >
                {isNameCapitalized
                    ? capitalize(item?.firstName)
                    : item?.firstName}{" "}
                  {isNameCapitalized
                    ? capitalize(item?.lastName)
                    : item?.lastName}                
                </p>
                {customType ? (
                  typeof customType === "string" ? (
                    <p className="text-[10px] text-[#D9D9D9]">{customType}</p>
                  ) : (
                    customType
                  )
                ) : (
                  <div className="flex justify-center gap-[2px] lg:gap-2">
                      <div className="min-w-[8px] w-2 mt-1 lg:mt-0 h-2 lg:w-3 lg:h-3 bg-[#10C700] rounded-full" />
                  <p className="text-[10px] text-[#D9D9D9]">
                    {!hideType &&
                      (item?.type === "ALLY" || !item?.type
                        ? ""
                        : `${userTypeConvert(item?.type as never)}, `)}
                    Actively Looking for{" "}
                    {/* {item?.lookingForType === "ALLY" || !item?.lookingForType ? "an" : "a"}{" "} */}
                    {item?.lookingForType
                      ? userTypeConvert(item?.lookingForType as never)
                      : "Connections"}
                  </p>
                  </div>
                )}

                {!hideMutual && (
                  <>
                    <div className="my-[6px] w-full h-[1px] border-b border-b-[#D9D9D9]" />

                    <div className="flex flex-col items-center gap-[6px]">
                      <p className="text-[10px] text-[#D9D9D9]">Mutual Connections</p>
                      <p
                        className="bg-[#DAFFD6] text-[#158284] w-6 h-6 rounded-full flex items-center justify-center"
                        onClick={() => setShowMutualConnection({ isOpen: true, userId: item?.id })}
                      >
                        {mutualCount}
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          {variant === "horizontal" && (
            <div className={cx(
              `flex gap-4 items-center`,isOneLineName && "max-w-full",
               containerClassName
            )}>
              <div>
                <Avatar
                  src={item?.avatarUrl}
                  alt="avatar"
                  badge={hideCG ? null : CGP}
                  type_tier={typeTier() as never}
                  badgeXPos={squareAvatar ? "right" : "center"}
                  size={avatarSize || "lg"}
                  isRounded={!squareAvatar}
                  styleTier={styleTier}
                  name={item?.firstName}
                />
              </div>
              <div className={cx(isOneLineName && "min-w-0")}>
                {!hideJobType && <p className="text-[10px] text-[#D9D9D9]">{item?.jobTitle}</p>}
                <p className={cx(
                  `text-sm font-bold`,
                  isChampion && "text-yellow",
                  isOneLineName && "truncate",
                  nameClassName
                )}>
                  {isNameCapitalized
                      ? capitalize(item?.firstName)
                      : item?.firstName}{" "}
                  {isNameCapitalized
                    ? capitalize(item?.lastName)
                    : item?.lastName}    
                </p>
                {customType ? (
                  typeof customType === "string" ? (
                    <p className="text-[10px] text-[#D9D9D9]">{customType}</p>
                  ) : (
                    customType
                  )
                ) : (
                  <p className="text-[10px] text-[#D9D9D9]">
                    {!hideType && (
                      <>
                        {!hideOnlyType && (item?.type === "ALLY" || !item?.type ? "" : `${userTypeConvert(item?.type as never)}, `)}
                        Actively Looking for{" "}
                        {/* {item?.lookingForType === "ALLY" || !item?.lookingForType ? "an" : "a"}{" "} */}
                        {item?.lookingForType
                          ? userTypeConvert(item?.lookingForType as never)
                          : "Connections"}
                      </>
                    )}
                  </p>
                )}
              </div>
            </div>
          )}
        </Wrapper>
      )}

      {showMutualConnection?.isOpen && (
        <ModalMutualConnection
          idUser={showMutualConnection?.userId}
          isOpen={showMutualConnection?.isOpen}
          onClose={() =>
            setShowMutualConnection({
              isOpen: false,
              userId: null,
            })
          }
        />
      )}
    </>
  );
}
